var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canView)?_c('slots-list',{attrs:{"item-key":"id","headers":_vm.headers,"slots":_vm.slots,"loading":_vm.loading,"loading-text":"Đang Tải","startDate":_vm.start,"endDate":_vm.end},on:{"change":_vm.onDateChanged}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }